module.exports = __webpack_public_path__ + "static/media/Niveau_elN7_1_416327.2cf5940c.png";